// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlternanciaController from "./alternancia_controller"
application.register("alternancia", AlternanciaController)

import ColapsaveisController from "./colapsaveis_controller"
application.register("colapsaveis", ColapsaveisController)

import EquipamentoFormController from "./equipamento_form_controller"
application.register("equipamento-form", EquipamentoFormController)

import ExpansaoController from "./expansao_controller"
application.register("expansao", ExpansaoController)

import GraficoController from "./grafico_controller"
application.register("grafico", GraficoController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import JobScheduleFormController from "./job_schedule_form_controller"
application.register("job-schedule-form", JobScheduleFormController)

import MarcacaoController from "./marcacao_controller"
application.register("marcacao", MarcacaoController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import ProcessandoController from "./processando_controller"
application.register("processando", ProcessandoController)

import SolicitanteRapidoController from "./solicitante_rapido_controller"
application.register("solicitante-rapido", SolicitanteRapidoController)
